import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import search_query from "ulysses/widgets/search/search_query";
import search_columns from "ulysses/widgets/search/search_columns";
import export_dialog from "ulysses/widgets/search/search_export.html";
import export_selector from "ulysses/widgets/search/select_search_export.html";

$.extend(uly.actions, {
    "search_next": function (ev, $elt, ui) {
        var start_index = ko.unwrap(ui.model.start_index);
        var page_size = ko.unwrap(ui.model.page_size);
        ui.model.start_index(start_index + page_size);
    },
    "search_prev": function (ev, $elt, ui) {
        var start_index = ko.unwrap(ui.model.start_index);
        var page_size = ko.unwrap(ui.model.page_size);
        ui.model.start_index(start_index - page_size);
    },
    "editgridcolumns": function (ev, $elt, ui) {
        console.log("got ui:", ui);
        var search_model = uly.actions.get_search_model_from_context(ui.context);
        var search_settings = uly.actions.get_search_settings_from_context(ui.context);
        var model = uly.actions.get_search_widget_from_context(ui.context);
        var included_columns = $.map(search_settings.columns || [{
            "caption": _("search_caption_title", "Title"),
            "field": "title_t"
        }], function (c) {
            return c.field;
        });
        select_columns(search_model, ko.toJS(search_settings), ui.context, included_columns).then(function (result) {
            var columns = $.map(result.main_columns.concat(result.extra_columns), function (c) {

                if (ko.unwrap(c.included)) {
                    return {
                        "field": c.field_name,
                        "caption": c.caption
                    };
                }
            });
            var settings = $.extend({}, ko.unwrap(model.settings));
            settings.columns = columns;
            if (model.settings) {
                model.settings(settings);
                uly.publish("page.savesettings");
            } else if (model.search_settings) {
                model.search_settings(settings);
                uly.publish("page.savesettings");
            }

        });
    },
    exportsearchresult: function (ev, $elt, ui) {
        var search_model = uly.actions.get_search_model_from_context(ui.context);
        var search_settings = uly.actions.get_search_settings_from_context(ui.context) || {};
        if (!search_settings.filter && !search_settings.query) {
            try {
                search_settings = search_model.get_search_configuration()
            } 
            catch(e) {
                console.error("Error producing correct settings");
            }
        }
        select_columns(search_model, ko.toJS(search_settings), ui.context, ["id", "title_t"])
            .then(function (result) {
                var columns = result.columns.map((col) => { return col.field_name + ":" + col.caption; });

                var query = result.query;
                query["search_field"] = "_search_field";
                var fq = result.fq;
                var progress = ko.observable("25%");
                var status = ko.observable(_("search_creating_file", "Creating file..."));
                var location = null;
                uly.dialogs.progress_dialog(_("search_csv_export", "CSV Export"), status, progress);
                uly.api.start().follow("uly:search")
                    .post("uly:resultset", {
                        "q": query,
                        "fq": fq,
                        "columns": columns
                    })
                    .done(function (result) {
                        var counter = 1;
                        var percent = 33;
                        location = result.location;
                        function checkFile() {
                            $.get(location).done(function (result) {
                                if (result.ready) {
                                    progress("100%");
                                    window.open(uly.api.getAuthenticatedUrl(location + "/download"));
                                    status(null);
                                } else if (result.completed) {
                                    progress("100%");
                                    uly.utils.show_results({
                                        "success": false,
                                        "error": result.error
                                    });
                                    status(null);
                                } else {
                                    percent = percent + Math.round((100 - percent) / 4);
                                    progress("" + percent + "%");
                                    setTimeout(checkFile, 1000);
                                }
                            }).fail(function (result) {
                                uly.utils.show_results({
                                    "success": false,
                                    "error": result.error
                                });
                                status(null);
                            });
                        }

                        if (result.epic_id) {
                            uly.dialogs.progress_epic(_("search_csv_export", "CSV Export"), result.epic_id, result.info);
                            status(null);
                            let epicSub = null;
                            epicSub = uly.subscribeToEpic(result.epic_id, function(topic, data) {
                                if (data.finished) {
                                    uly.unsubscribeToEpic(result.epic_id, epicSub);
                                    checkFile();
                                }
                            });
                        } else {
                            if (result.success && result.location) {
                                //need to show something.
                                location = result.location;
                                status(_("search_waiting_for_file", "Waiting for file"));
                                progress("33%");
                                setTimeout(checkFile, 1000);
                            }
                        }
                    });
            }).fail(function (result) {
                console.error("got error", result);
            });
    },
    savesearchfilter: function (ev, $elt, ui) {
        var search_model = uly.actions.get_search_model_from_context(ui.context);
        if (!search_model) {
            uly.utils.show_results({
                "success": False,
                "error": _("search_actions_no_filter_to_save", "Cannot save a search filter.")
            });
        }
        //TODO Encapsulate below
        let data = {
            "filter_name": null,
            "filter_description": null,
            is_public: false
        };

        var cf = search_model.current_filter();
        console.log("Got CF:", cf);
        if (cf && cf.name) {
            data.filter_name = cf.title || cf.name;
            data.filter_description = cf.description;
            data.is_public = cf.is_public;
        }

        
        uly.dialogs.show("dlg_save_search_filter", {}, data).then(function ([result]) {
            var filter_data = search_model.get_search_configuration();
            let new_filter = {
                "title": result.filter_name,
                "name": result.filter_name,
                "description": result.filter_description,
                "filter_data": filter_data,
                "is_public": result.is_public
            };
            console.log("Saving Search filter:", new_filter, result);

            return uly.api.start().follow("uly:search").post(null, new_filter).then((r) => {
                if (new_filter.name)
                    search_model.current_filter(new_filter);
                search_model.query_results();
                return r;
            });
        }).then(function (result) {
            uly.utils.show_results(result);
        });
    },
    loadsearchfilter: function (ev, $elt, ui) {},
    selectexportconfiguration: function(ev, $elt, ui) {
        var model_data = ui.model;
        var search_model = ui.context.$parent.search_model;
        var dialog_data = { 
            configs: model_data.configs,
            selected: ko.observable(null),
            select_item: function(item, ev) { 
                dialog_data.selected(item);
                $(ev.target).trigger("action:closedialog", { context: { $data: dialog_data }});
            }
        };
        if (!model_data || !model_data.configs || model_data.configs().length <= 0) {
            return uly.utils.show_results({
                "success": false,
                "error": _("search_actions_no_export_config_to_load", "No saved configuration yet.")
            });
        }

        return uly.dialogs.execute(export_selector, {
            "title": _("search_title_select_export_config", "Select configuration"),
            "raw_data": true
        },
        dialog_data
        ).then(function ([result]) {
            if (result.selected && result.selected.name) {
                uly.api.start()
                    .follow("uly:search")
                    .follow("uly:exports", { "name": result.selected.name})
                    .then((search_export) => {
                        search_model.current_export(search_export);
                        var cols = search_export.columns;
                        model_data.include_columns(cols);
                    });
            }
        });
    },
    saveexportconfiguration: function(ev, $elt, ui) {
        var search_model = ui.context.$parent.search_model;
        var dlg_data = ui.context.$parent.dialog_data;
        if (!search_model || !dlg_data) {
            return uly.utils.show_results({
                "success": false,
                "error": _("search_actions_no_context", "Not able to execute this action at the moment.")
            });
        }
        var selected_columns = dlg_data.selected_columns();
        var data = {
            "name": "",
            "description": "",
            is_public: false
        };
        var ce = search_model.current_export();
        if (ce) {
            data.name = ce.name;
            data.title = ce.title;
            data.description = ce.description;
            data.is_public = ce.is_public;

        }

        
        uly.dialogs.show("dlg_save_search_export", {}, data).then(function ([result]) {
            var search_data = search_model.get_search_configuration();
            let new_filter = {
                "title": result.name,
                "name": result.name,
                "description": result.description,
                "export_data": { 
                    "columns": selected_columns.map((v) => ko.unwrap(v.field_name)),
                    "search_query": search_data.search_query
                },
                "is_public": result.is_public
            };

            return uly.api.start().follow("uly:search").post("uly:columns", new_filter).then((r) => {
                if (new_filter.name)
                    search_model.current_export(new_filter);
                search_model.query_results();
                return r;
            });
        }).then(function (result) {
            uly.utils.show_results(result);
        });
    }

});


function select_columns(search_model, search_settings, context, included_columns) {
    var query = search_query.computeSearchQuery(search_model, search_settings, context);
    var fq = query.fq;
    delete query.fq;
    //hack to fix some serialisation issue
    if (query.cf && typeof query.cf.push === "function") {
        query.cf = ko.toJSON(query.cf);
    }
    return uly.api.start()
        .follow("uly:search")
        .follow("uly:columns", {
            "q": query,
            "fq": fq
        })
        .then(function (columns) {
            var _last_idx = 0;

            var columns_data = new search_columns.Columns(columns);

            uly.api.start().follow("uly:search").follow("uly:exports", {
                "q": query,
                "fq": fq
            }).then((result) => {
                if (result.configs) {
                    columns_data.configs(result.configs);
                }
            });

            included_columns = included_columns || ["title_t"];
            columns_data.flat_columns().forEach((col)=>{
                if (included_columns.indexOf(col.field_name) >= 0) {
                    columns_data.select_column(col);
                }
            });

            return uly.dialogs.execute(export_dialog, {
                "title": _("search_title_select_columns", "Select columns"),
                "buttons": {
                    "ok": { caption: _("search_export_select_columns_ok", "Ok"), "colour": "primary", "icon": "fa-check-circle" },
                    "cancel": { caption: _("search_export_select_columns_cancel", "Cancel"), "icon": "fa-times-circle" },
                    "save_export": { caption: _("search_export_select_columns_save_export", "Save"), "action": "saveexportconfiguration", "colour": "success", "icon": "fa-save" },
                },
                "raw_data": true,
                "search_model": search_model
            }, columns_data).then(function ([result]) {
                result.query = query;
                result.fq = fq;
                result.columns = columns_data.selected_columns();
                return result;
            });
        });
}
